import { defineComponent as y, ref as C, computed as o } from "vue";
import M from "./index14.js";
import S from "./index15.js";
import b from "../../../search/ui/components/available_contracts/index.js";
import T from "./index16.js";
import { DropdownMenuTypes as N, DropdownMenuItem as h } from "@ado/dropdown-menu-ld";
import w from "./index12.js";
import "../../../shared/data/configuration/state/index2.js";
import "@ado/base-service";
import "@ado/location-library";
import "@ado/cookie-library";
import "../../../shared/data/csr/state/index2.js";
import { getLayout as v, setShowMobileMenu as k } from "../../../shared/data/layout/state/index.js";
import { BannerStyle as a } from "../../../shared/data/layout/state/index2.js";
import "../../../shared/data/location/state/index.js";
import "../../../shared/data/navigation/state/index2.js";
import "@ado/experiment-library";
import "../../../search/state/index2.js";
import "../../../shared/data/user/state/index2.js";
import "@ado/acs-standard-library";
import D from "./index17.js";
import { submitInternalEvent as I } from "@ado/tracking-library";
import { TRACKING_EVENTS as L } from "../../../shared/data/tracking/types/index.js";
import { createMenuCategoryNameTranslator as _ } from "../utilities/navigation_menu_category_translation/index.js";
import "@ado/dropdown-menu-ld/style.css";
import { useBaseApplicationTranslation as E } from "../../../shared/libraries/local-translations/index.js";
const ne = y({
  name: "Navigation",
  components: {
    MenuCategory: M,
    ContractsSearch: b,
    NavigationSkeleton: S,
    NavigationSkeletonMobile: T,
    HeaderAccount: w,
    MobileHeader: D
  },
  props: {
    menuCategories: {
      type: Array,
      default: () => []
    },
    showSearch: {
      type: Boolean,
      default: !0
    },
    user: {
      type: Object,
      required: !0
    },
    config: {
      type: Object,
      required: !0
    },
    bannerStyle: {
      type: String,
      required: !0
    }
  },
  setup(t) {
    const m = C("/help/"), i = o(() => t.menuCategories.length === 0), p = (n) => n.items.map((e) => {
      const g = {
        ...L.PRODUCT_MENU_PRODUCT_CLICK,
        component: n.name,
        extra: e.name
      };
      return h.newLinkItem(
        e.url,
        e.name,
        e.url
      ).setOnClickHandler(() => I(g));
    }), { t: s, isLoaded: u } = E(), l = () => {
      k(!1);
    }, c = o(() => v().showMobileMenu), f = o(
      () => t.bannerStyle === a.SelectionPage
    ), r = _(
      t.config
    ), d = r.translateName.bind(r);
    return {
      menuTypes: N,
      isDataUnavailable: i,
      helpLink: m,
      showMenu: c,
      closeMenu: l,
      convertToDropdownItems: p,
      BannerStyle: a,
      isSelectionPageBanner: f,
      areTranslationsLoaded: u,
      t: s,
      translateMenuCategoryName: d
    };
  }
});
export {
  ne as default
};
//# sourceMappingURL=index8.js.map
